'use strict';

var _ = require('lodash');
var ChartDemandAdjustmentDataService = function ChartDemandAdjustmentDataService(colorScales) {
  var colorScaleUserData = colorScales.colorScale26a();
  var colorScaleModelData = colorScales.colorScale26b();
  function transformData(data, compareMode) {
    var total = _.sumBy(data.model, 'value');
    var mergedModelUserData = prepareMergedData(data.model, data, total);
    var separatedData = calculateSeperated(mergedModelUserData, data.model, total, compareMode);
    var totalData = calculateTotal(data.effective, data.model, separatedData, compareMode);
    return {
      separated: separatedData,
      total: totalData
    };
  }
  function prepareMergedData(modelData, data, total) {
    var userData = data.user;
    var effData = data.effective;
    var values = [];
    if (modelData) {
      for (var i = 0; i < modelData.length; i++) {
        var modelValue = modelData[i];
        var userValue = userData[i];
        var effValue = effData[i];
        var val = userValue && !_.isNil(userValue.value) ? userValue.value * total : !_.isNil(effValue) && !_.isNil(effValue.value) ? effValue.value : modelValue.value;
        values.push({
          groupId: modelValue.groupId,
          value: val
        });
      }
    }
    return values;
  }
  function calculateSeperated(mergedModelUserData, modelData, total, compareMode) {
    var numberOfColors = colorScaleUserData.domain().length + 1;
    var step = Math.floor(numberOfColors / mergedModelUserData.length);
    var index = 0;
    return _.map(mergedModelUserData, function (e) {
      var colorIndex = index % numberOfColors + 1;
      var separatedData = {
        value: e.groupId,
        items: []
      };
      if (compareMode) {
        var compareModeData = buildCompareModeSeparatedChartData(e, modelData, colorScaleModelData(colorIndex), total);
        separatedData.items.push(compareModeData);
      }
      separatedData.items.push(buildUserSeparatedChartData(e, colorScaleUserData(colorIndex), total));
      index += step;
      return separatedData;
    });
  }
  function calculateTotal(effectiveData, modelData, separatedDataArray, compareMode) {
    var result = [];
    if (compareMode) {
      result.push(buildTotalChartData(modelData, separatedDataArray, 'Model', _.first));
    }
    result.push(buildTotalChartData(effectiveData, separatedDataArray, 'Total', _.last));
    return result;
  }
  function buildTotalChartData(data, separatedDataArray, dataName, getElement) {
    var totalResult = [];
    data.forEach(function (entry) {
      var newValue = entry.value + (totalResult.length ? totalResult[totalResult.length - 1] : 0);
      totalResult.push(newValue);
    });
    var fill = _.map(separatedDataArray, function (element) {
      return getElement(element.items).fill;
    });
    return {
      value: dataName,
      data: totalResult.reverse(),
      fill: fill.reverse()
    };
  }
  function buildUserSeparatedChartData(e, fill, total) {
    return {
      value: e.groupId,
      fill: fill,
      share: total !== 0 ? e.value / total : 0
    };
  }
  function buildCompareModeSeparatedChartData(mergedModelUserData, modelData, fill, total) {
    var matchingModelData = _.find(modelData, function (model) {
      return model.groupId === mergedModelUserData.groupId;
    });
    return {
      value: matchingModelData.groupId,
      fill: fill,
      share: total !== 0 ? matchingModelData.value / total : 0
    };
  }
  return {
    transformData: transformData
  };
};
ChartDemandAdjustmentDataService.$inject = ['RmColorScales'];
module.exports = ChartDemandAdjustmentDataService;